// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import LoadMoreController from "./load_more_controller";
application.register("load-more", LoadMoreController);

import NavController from "./nav_controller";
application.register("nav", NavController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import ScrollController from "./scroll_controller";
application.register("scroll", ScrollController);
